import { render, staticRenderFns } from "./assignedUser.vue?vue&type=template&id=45a6a840&"
import script from "./assignedUser.vue?vue&type=script&lang=js&"
export * from "./assignedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports